<!--
 * @Description: 
 * @Date: 2022-12-01 09:41:56
-->
<template>
  <div class="box-flex-column">
    <BaseTabs v-model="active">
      <BaseTabPane :name="2" label="按项目展示"></BaseTabPane>
      <BaseTabPane :name="1" label="按人展示"></BaseTabPane>
    </BaseTabs>

    <BaseLayoutFlexContent>
      <xrk-table
        v-if="active === 1"
        :getListAjax="terminalPay"
        :request-now="true"
        :search-config="personSearchConfig"
        :tableConfig="{
          tableColumns: personTableColumn
        }"
        :paginationConfig="{
          paginationPageSize: 15
        }"
        ref="tableRenderRef"
      >
        <template #tableAfter>
          <div
            style="
              font-size: 14px;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              margin: 16px 0 0 10px;
            "
          >
            <span style="color: #697077">累计终端结算金额：</span>
            <span style="color: #121619; font-weight: 600">
              {{ listAmount }}
            </span>
          </div>
        </template>
      </xrk-table>
      <xrk-table
        v-if="active === 2"
        :request-now="true"
        :getListAjax="terminalPay"
        :search-config="projectSearchConfig"
        :tableConfig="{
          tableColumns: projectTableColumn
        }"
        :paginationConfig="{
          paginationPageSize: 15
        }"
        ref="tableRenderRef"
      >
        <template #tableAfter>
          <div
            style="
              font-size: 14px;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              margin: 16px 0 0 10px;
            "
          >
            <span style="color: #697077">累计终端结算金额：</span>
            <span style="color: #121619; font-weight: 600">
              {{ listAmount }}
            </span>
          </div>
        </template>
      </xrk-table>
    </BaseLayoutFlexContent>
  </div>
</template>
<script lang="tsx" setup>
import { ref } from 'vue';
import {
  BaseTabs,
  BaseTabPane,
  XrkTable,
  XrkTableRef,
  BaseLayoutFlexContent
} from 'xrk-components';
import { projectTableColumn, personTableColumn } from '../hook/create-table';
import { projectSearchConfig, personSearchConfig } from '../hook/create-search';
import { terminalPayList } from '@/views/industry-terminal-pay/src/data-source/apis';
import { dealParam, state } from '../hook/use-event';
import { money } from 'xrk-tools';

const active = ref<number>(1);
const tableRenderRef = ref<XrkTableRef>(null);
const listAmount = ref<string | number>('');

const terminalPay = async params => {
  state['active'] = active;
  state['tableRenderRef'] = tableRenderRef;
  const newParam = dealParam(params);
  const data = await terminalPayList(newParam);
  listAmount.value = money.moneyFixed(data.data.remark.totalPrice || 0);
  return data;
};
</script>
<style lang="scss" scoped>
::v-deep {
  .xrk-form-item__label-wrap {
    margin-right: 0px !important;
  }
}
</style>
